<template>
  <div>
    <page-header
      :page="page"
      :has-return="false"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="ab-btn  ab-btn-outline-success m-1"
          @click="onReturn"
        >
          Regresar
        </ActionButton>
        <ActionButton i="fas fa-save" variant="ab-btn  ab-btn-success m-1">
          Guardar
        </ActionButton>

        <ActionButton i="fas fa-flag-alt" variant="ab-btn  ab-btn-success m-1">
          Someter
        </ActionButton>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <Board v-if="studentDetails" :details="studentDetails" />
        <div class="row bg-gray m-0 d-flex">
          <div class="col-12 col-md-4 px-5">
            <div>
              <span class="font-14 color-secondary-6">
                Número de Cita:
              </span>
              <p class="font-16 font-weight-normal">
                {{ $route.params.appointmentId }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4 px-5">
            <div>
              <span class="font-14 color-secondary-6">
                Tipo de Evaluación:
              </span>
              <p class="font-16 font-weight-normal">
                {{ appointment.evaluationType }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-4 px-5">
            <div>
              <span class="font-14 color-secondary-6">
                Servicio:
              </span>
              <p class="font-16 font-weight-normal">
                {{ appointment.disciplineName }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-5 ">
        <b-tabs content-class="mt-3" fill>
          <b-tab title="I" active><p>I</p></b-tab>
          <b-tab title="II"><p>I'm the second tab</p></b-tab>
          <b-tab title="III"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="IV"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="V"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="VI"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="VII"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="VIII"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="IX"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="X"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="XI"><p>I'm a disabled tab!</p></b-tab>
          <b-tab title="Notas y Firma"><p>I'm a disabled tab!</p></b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import studentApi from '@/services/student.js';
import ActionButton from 'ActionButton';
import moment from 'moment';
import appointmentServices from '@/services/api/appointment.api';
export default {
  name: 'SpeechAndLanguage',
  components: {
    PageHeader,
    Board,
    ActionButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-tie',
        title: 'Informe de Evaluación del Habla y Lenguaje',
        routes: ['Proveedor', 'Evaluación del Habla y Lenguaje'],
      },
      student: null,
      appointment: null,
    };
  },
  computed: {
    studentDetails() {
      if (!this.student) return;
      return [
        [
          {
            label: 'Estudiante:',
            data: this.student.fullName,
            icon: 'fas fa-address-book',
          },
          {
            label: 'SIE:',
            data: this.student.studentId,
            icon: 'fas fa-clipboard-list-check',
          },

          {
            label: 'Edad Cronológica:',
            data: `${this.getChronologicalAge(this.student.dateOfBirth)} `,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Corporación:',
            data: this.appointment.companyName,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
  },
  methods: {
    async getAppointmentInfo(id) {
      const { data } = await appointmentServices.getAppointmentInfo(id);
      this.appointment = data;
    },
    getChronologicalAge(birthDate) {
      const toDate = moment(birthDate);
      const today = moment();

      const years = today.diff(toDate, 'years');
      const months = today.diff(toDate, 'months');

      const age = `${years}.${String(months % 12).padStart(2, '0')}`;

      return age;
    },
    async getStudent(sie) {
      const { data } = await studentApi.getBySie(sie);
      this.student = data;
    },
    onReturn() {
      this.$router.push({ name: 'AppointmentManagement' });
    },
  },
  async created() {
    await Promise.all([
      this.getStudent(this.$route.params.sie),
      this.getAppointmentInfo(this.$route.params.client),
    ]);
  },
};
</script>

<style lang="scss">
.nav.nav-tabs > .nav-item {
  background: #f2f2f2;
  min-width: 98px;
  height: 55px;
  text-align: center;
  a.active {
    background-color: #ff7058;
    border-color: #ff7058;
    color: white;
    &::after {
      bottom: -1px;
      border-right: 0.4rem solid transparent;
      border-bottom: 0.4rem solid;
      border-left: 0.4rem solid transparent;
    }
  }
}
</style>
